import VerticalIcon from './Vertical'
import MoreIcon from './More'
import CloseIcon from './Close'
import ExpandIcon from './Expand'
import CollapseIcon from './Collapse'
import NextIcon from './Next'
import BackIcon from './Back'
import ExternalLinkIcon from './ExternalLink'
import RightArrowIcon from './RightArrow'

const Navigation = {
    VerticalIcon,
    MoreIcon,
    CloseIcon,
    ExpandIcon,
    CollapseIcon,
    NextIcon,
    BackIcon,
    ExternalLinkIcon,
    RightArrowIcon
}
export default Navigation
